import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PUBLIC_ROUTES } from '@/constants/routes';

/**
 * Redirects unauthenticated users to login page while preserving
 * the intended destination URL for redirect after login.
 */
export default function AuthRedirect() {
  const location = useLocation();

  useEffect(() => {
    // Save current URL (including search params) to sessionStorage
    const returnUrl = location.pathname + location.search;
    // Don't save login/register pages as return URL
    if (!returnUrl.startsWith('/login') && !returnUrl.startsWith('/register')) {
      sessionStorage.setItem('returnUrl', returnUrl);
    }
  }, [location]);

  return <Navigate to={PUBLIC_ROUTES.LOGIN} replace />;
}
